/**
 * Normaliza un valor numérico opcional:
 * - Si el valor es null, undefined o string vacío, retorna null.
 * - Si es string solo de dígitos, retorna como número.
 * - Si no, retorna el valor original.
 */
export const numeroNormalizado = valor => {
  if (valor === null || valor === undefined || valor === '') return null;
  if (typeof valor === 'string' && /^-?\d+$/.test(valor)) return Number(valor);
  return valor;
};

/**
 * Limpia y normaliza un valor string:
 * - Si el valor es null o undefined, retorna null.
 * - Si el valor es string vacío o solo espacios, retorna null.
 * - Si no, retorna el string limpio (sin espacios al inicio/fin).
 * - Si el valor no es string, lo convierte a string antes de limpiar.
 * @param {*} valor - Valor a limpiar.
 * @returns {string|null} String limpio o null si está vacío.
 */
export const limpiarString = valor => {
  if (valor === null || valor === undefined) return null;
  const limpio = String(valor).trim();
  return limpio === '' ? null : limpio;
};
